// Guide selector — collapse current, open new
const guideBtns = document.querySelectorAll('.guide-btn');
const guidePanels = document.querySelectorAll('.guide-panel');

if (guideBtns.length && guidePanels.length) {
  guideBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.guide;
      const isActive = btn.classList.contains('active');
      
      guideBtns.forEach(b => b.classList.remove('active'));
      guidePanels.forEach(p => p.classList.remove('active'));
      
      if (!isActive) {
        btn.classList.add('active');
        const targetPanel = document.querySelector(`[data-panel="${target}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
          targetPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
}

// Method tabs (ring sub-tabs)
document.querySelectorAll('.method-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const method = tab.dataset.method;
    const panel = tab.closest('.guide-panel');
    if (panel) {
      panel.querySelectorAll('.method-tab').forEach(t => t.classList.remove('active'));
      panel.querySelectorAll('.method-content').forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      const targetContent = panel.querySelector(`[data-content="${method}"]`);
      if (targetContent) targetContent.classList.add('active');
    }
  });
});

// Accordion — shared handler
document.querySelectorAll('.acc-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.acc-item');
    if (item) item.classList.toggle('open');
  });
});
